import React, { Dispatch, SetStateAction } from "react"
import {
  OrderOperationSearchHit,
  OrderOperationSearchHits
} from "lib/types/generated/graphql-types"
import { CheckIcon, EmptyWrapper } from "../../views/Dashboards/OperationDashboard.styled"
import LoadingOperations from "./LoadingOperations"
import OperationRow from "./OperationRow"
import { ApolloQueryResult } from "@apollo/client"

type Props = {
  hits: OrderOperationSearchHit[]
  getStoreGroupName: (storeGroupId: string) => string | undefined
  loading: boolean
  refetchOperations: () => Promise<ApolloQueryResult<OrderOperationSearchHits>>
  pending?: boolean
  setCreatedOperations: Dispatch<SetStateAction<OrderOperationSearchHit[]>>
  setFailedOperations: Dispatch<SetStateAction<OrderOperationSearchHit[]>>
}

const Operations = ({
  hits,
  getStoreGroupName,
  loading,
  refetchOperations,
  pending,
  setCreatedOperations,
  setFailedOperations
}: Props) => {
  if (loading) return <LoadingOperations numberOfOperations={3} />

  if (hits?.length === 0) {
    return (
      <EmptyWrapper>
        <CheckIcon />
        <b>Nothing to do here</b>
      </EmptyWrapper>
    )
  }

  return (
    <>
      {hits?.map((operation) => (
        <OperationRow
          key={operation.id}
          getStoreGroupName={getStoreGroupName}
          operation={operation}
          refetchOperations={refetchOperations}
          pending={pending}
          setCreatedOperations={setCreatedOperations}
          setFailedOperations={setFailedOperations}
        ></OperationRow>
      ))}
    </>
  )
}

export default Operations
